import axios from "axios";
import qs from "qs";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 默认主题

import config from "../../static/config/config";
//测试服
let publicPath = config.serverIP; //"http://115.28.187.3:8081/hnswc_business_protal"
export default publicPath;
axios.defaults.baseURL = publicPath; //+"/api"
let ajaxNum = 0;
let loading = null;

//添加请求拦截器
axios.interceptors.request.use(
  config => {
    // loading = vueRef.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    // })
    // ajaxNum++;
    let query = qs.parse(location.hash.substring(3));
    var token = "1"; //token 写死即可
    config.headers.token = token;
    if (!config.isJsonRequest) {
      config.headers["Content-Type"] =
        "application/x-www-form-urlencoded;charset=UTF-8";
      if (config.method === "post") {
        config.data = qs.stringify(config.data);
      }
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  error => {
    ajaxNum--;
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // ajaxNum--
    // if (ajaxNum <= 0) loading.close();
    return response;
  },
  function(error) {
    // ajaxNum = 0
    // loading.close();
    return Promise.reject(error);
  }
);

let abnormalInter = function(err) {
  console.log(err);
  // vueRef.$message({
  //     type: 'error',
  //     message: "请求异常"
  // });
};

const tokenError = () => {
  let loginLock = localStorage.getItem("lockLock");
  if (!loginLock) {
    localStorage.setItem("loginLock", 1);
    vueRef.$message({
      type: "error",
      message: "登录过期，请重新登录！"
    });
  }
  setTimeout(() => {
    localStorage.removeItem("loginLock");
  }, 3000);
};

let intercept = function(res) {
  if (res.data.code == 405) {
    //未授权
    tokenError();
    vueRef.$router.push({
      path: "/login"
    });
  } else {
    return res.data;
  }
};

//封装导出回调函数用于下载bob流文件
let downloadFileCallBack = function(res) {
  const blob = new Blob([res.data], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
  });
  const downloadElement = document.createElement("a");
  const href = window.URL.createObjectURL(blob);
  let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
  let result = patt.exec(contentDisposition);
  let filename = decodeURI(result[1]);
  downloadElement.style.display = "none";
  downloadElement.href = href;
  downloadElement.download = filename; //下载后文件名
  document.body.appendChild(downloadElement);
  downloadElement.click(); //点击下载
  document.body.removeChild(downloadElement); //下载完成移除元素
  window.URL.revokeObjectURL(href); //释放掉blob对象
};

/**
 * 对象转为get参数
 * 例如
 * {
 *   name:a,
 *   age:10
 * }
 * 转换为 ?name=a&age=10
 * @param obj
 * @returns {string}
 */
function object2Params(obj) {
  const len = Object.getOwnPropertyNames(obj).length;
  if (len === 0) {
    return "";
  }
  let result = "?";
  for (const key in obj) {
    result += key + "=" + obj[key] + "&";
  }
  result = result.substring(0, result.length - 1);
  return result;
}
//水保新闻
export const getNewsPage = params => {
  return axios
    .post("/news/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
//水保新闻查询
export const getNewsById = params => {
  return axios
    .get(`/news/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//信息公告
export const getNoticePage = params => {
  return axios
    .post("/notice/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//水保公报
export const getNoticePageOfBulletin = params => {
  return axios
    .post("/notice/pageOfBulletin", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//信息公告查询
export const getNoticeById = params => {
  return axios
    .get(`/notice/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//监督管理
export const getSupervisionPage = params => {
  return axios
    .post("/supervision/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
//信息公告查询
export const getSupervisionById = params => {
  return axios
    .get(`/supervision/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//综合治理
export const getComprehensivePage = params => {
  return axios
    .post("/comprehensive/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getComprehensiveById = params => {
  return axios
    .get(`/comprehensive/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
//检测评价
export const getMonitoringPage = params => {
  return axios
    .post("/monitoring/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getMonitoringById = params => {
  return axios
    .get(`/monitoring/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
//相关站点
export const getRelatedWebsitesPage = params => {
  return axios
    .post("/relatedWebsites/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//相关站点
export const getRegulationsPage = params => {
  return axios
    .post("/regulation/pageRegulation", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getRegulationById = params => {
  return axios
    .get(`/regulation/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//灾难预留

export const getDisasterPlanPage = params => {
  return axios
    .post("/disasterPlan/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getDisasterPlanById = params => {
  return axios
    .get(`/disasterPlan/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
//科研成果
export const getAchievementsPage = params => {
  return axios
    .post("/achievements/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getAchievementsById = params => {
  return axios
    .get(`/achievements/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
//相关会议

export const getRelevantMeetingsPage = params => {
  return axios
    .post("/relevantMeetings/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getRelevantMeetingsById = params => {
  return axios
    .get(`/relevantMeetings/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getPlantResourcesPage = params => {
  return axios
    .post("/plantResources/page", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getPlantResourcesById = params => {
  return axios
    .get(`/plantResources/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getNewListNewsTop = params => {
  return axios
    .get(`/news/listNewsTop`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

//机构职能
export const getOfficeList = params => {
  return axios
    .post("/office/list", params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};
export const getOfficeById = params => {
  return axios
    .get(`/office/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getListPolularScience = params => {
  return axios
    .get(`/plantResources/listPolularScience`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getcreditDataPage = params => {
  return axios
    .post(`/creditData/page`, params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getCreditDataById = params => {
  return axios
    .get(`/creditData/get/${params.id}`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getSearchPage = params => {
  return axios
    .post(`/search/searchArticle`, params, {
      isJsonRequest: true
    })
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};

export const getHomePageNews = params => {
  return axios
    .get(`/news/homePagePicNews`, params)
    .then(res => {
      return intercept(res);
    })
    .catch(err => {
      abnormalInter(err);
    });
};



// WEBPACK FOOTER //
// ./src/api/index.js